import React, {useState} from 'react';


export default function TextForm(props) {
    document.title = props.title;
    const handleCapitalizeClick = ()=>{
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{  
            let newText = text.split(" ");
            for (let i = 0; i < newText.length; i++) {
                newText[i] = newText[i].charAt(0).toUpperCase() + newText[i].slice(1);
            }
            const capitalize = newText.join(" ");
            setText(capitalize);
            props.showAlert("Converted to Capitalize.", "success");
        }
    }
    const handleUpClick = ()=>{
        // console.log("Uppercase was clicked: " +  text);
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.toUpperCase();
            setText(newText);
            props.showAlert("Converted to Uppercase.", "success");
        }
    }
    const handleLoClick = ()=>{
        // console.log("Uppercase was clicked: " +  text);
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.toLowerCase();
            setText(newText);
            props.showAlert("Converted to Lowercase.", "success");
        }
    }
    const handleClearClick = ()=>{
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = "";
            setText(newText);
            props.showAlert("Text Cleared.", "success");
        }
    }
    const handleCopy = () => {
        // console.log("I am copy");
        var text = document.getElementById("myBox");
        if(text.value === ''){
            props.showAlert("Please enter some text.", "danger");
        }else{
            // text.select();
            navigator.clipboard.writeText(text.value);
            // document.getSelection().removeAllRanges();
            props.showAlert("Text Copied.", "success");
        }
    }

    const handleReplaceSpacesWithDashes = () => {
        var text = document.getElementById("myBox");
        if(text.value === ''){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.value.split(" ").join("-");
            setText(newText);
            props.showAlert("Spaces Replaced with Dashes.", "success");
        }
    }

    const handleReplaceDashesWithSpaces = () => {
        var text = document.getElementById("myBox");
        if(text.value === ''){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.value.split("-").join(" ");
            setText(newText);
            props.showAlert("Dashes Replaced with Spaces.", "success");
        }
    }

    const handleExtraSpaces = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.split(/[ ]+/);
            setText(newText.join(" "));
            props.showAlert("Extra spaces removed.", "success");
        }
    }

    const handleRepeatText = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.repeat(5);
            setText(newText);
            props.showAlert("Text Repeated.", "success");
        }
    }

    const handleReverseText = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            function reverseText(text){
                const arrayStrings = text.split("");
                const reverseArray = arrayStrings.reverse();
                const joinArray = reverseArray.join("");
                return joinArray;
            }
            let newText = reverseText(text);
            setText(newText);
            props.showAlert("Text Reversed.", "success");
        }
    }

    const handleTextToBinary = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            function text2Binary(string) {
                return string.split('').map(function (char) {
                    return char.charCodeAt(0).toString(2);
                }).join(' ');
            }
            let newText = text2Binary(text);
            setText(newText);
            props.showAlert("Text Convert to Binary.", "success");
        }
    }

    const handleEncode64 = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = btoa(text);
            setText(newText);
            props.showAlert("Text Encoded to Base64.", "success");
        }
    }

    const handleDecode64 = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = atob(text);
            setText(newText);
            props.showAlert("Text Decoded from Base64.", "success");
        }
    }

    const handleAddLineNum = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text.split('\n').map((line, index) => `${index + 1}. ${line}`).join('\n');
            setText(newText);
            props.showAlert("Line numbers added.", "success");
        }
    }
    
    const handleOnChange = (event)=>{
        setText(event.target.value);
    }

    const handleOnChange2 = (event)=>{
        setPrefix(event.target.value);
    }
    const handleAddPrefix = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = prefix + ' ' + text;
            setText(newText);
            props.showAlert("Prefix Added.", "success");
        }
    }

    const handleOnChange3 = (event)=>{
        setSuffix(event.target.value);
    }
    const handleAddSuffix = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let newText = text + ' ' + suffix;
            setText(newText);
            props.showAlert("Suffix Added.", "success");
        }
    }
    const handleSplitByCapitalLetter = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let splitText = text.split(/(?=[A-Z])/).join("\n");
            setText(splitText);
            props.showAlert("Text Splited by Capital Letter & Moved to Next Line.", "success");
        }
    }
    const handleSplitByCapitalLetterWithSpace = () => {
        if(text.length === 0){
            props.showAlert("Please enter some text.", "danger");
        }else{
            let splitText = text.split(/(?=[A-Z])/).join(" ");
            setText(splitText);
            props.showAlert("Text Splited by Capital Letter with Space.", "success");
        }
    }
    

    function countWords(str) {
        const arr = str.split(/\s+/);
        return arr.filter(word => word !== "").length;

    }

    const [text, setText] = useState(''); 
    const [prefix, setPrefix] = useState(''); 
    const [suffix, setSuffix] = useState(''); 
    // text = "new text"; // Wrong way to change the state
    // setText("new text"); // Correct way to change the state
    
    return (
        <>
        <div className="container" style={{color: props.mode==='light'?'#042743':'white'}}> 
            <h2 className='mt-3 mb-3'>{props.heading}</h2>
            <div className="mb-3"> 
                <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='light'?'white':'#aba4a4', color: props.mode==='light'?'#042743':'white'}} id="myBox" rows="8"></textarea>
            </div>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCapitalizeClick}>Convert to Capitalize</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleUpClick}>Convert to Uppercase</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleLoClick}>Convert to Lowercase</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleClearClick}>Clear Text</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCopy}>Copy Text</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleReplaceSpacesWithDashes}>Replace Spaces with Dashes</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleReplaceDashesWithSpaces}>Replace Dashes with Spaces</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleRepeatText}>Repeat Text 5x</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleReverseText}>Reverse Text</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleTextToBinary}>Text to Binary</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleEncode64}>Text Encode Base64</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleDecode64}>Text Decode Base64</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleAddLineNum}>Add Line Numbers</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleSplitByCapitalLetter}>Split by Capital & Moved to Next Line</button>
            <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleSplitByCapitalLetterWithSpace}>Split by Capital with Space</button>
            <div className="row px-1 py-1">
                <div className="col-auto pe-0 mb-2">
                    <div className="input-group">
                        <input type="text" disabled={text.length===0} className="form-control" value={prefix} onChange={handleOnChange2} placeholder='Add Prefix' />
                        <button disabled={text.length===0} className="btn btn-primary" onClick={handleAddPrefix}>Add Prefix</button>
                    </div>
                </div>
                <div className="col-auto pe-0 mb-2">
                    <div className="input-group">
                        <input type="text" disabled={text.length===0} className="form-control" value={suffix} onChange={handleOnChange3} placeholder='Add Suffix' />
                        <button disabled={text.length===0} className="btn btn-primary" onClick={handleAddSuffix}>Add Suffix</button>
                    </div>
                </div>
            </div>
        </div>
        <div className="container my-3" style={{color: props.mode==='light'?'#042743':'white'}}>
            <h2>Your text summary</h2>
            {/* <p>{//text.length > 0 ? text.trim().split(" ").length : 0} words and {text.length} characters</p> */}
            <p>{countWords(text)} words and {text.length} characters</p>
            <p>{0.008 *  countWords(text)} Minutes read</p>
            <h2>Preview</h2>
            <p>{text.length>0?text:"Nothing to preview.!"}</p>
        </div>
        </>
    )
}
